import React, {Component} from 'react'
import { Card, Filter, Pan } from './'
import { searchTerm } from './../services/ApiController'
import { searchListStyle } from './../styles'
import {debounce} from 'lodash'
import { Load } from './Shapes'

export default class SearchList extends Component {
  state = {
    products: [],
    filters: [],
    filterProduct: null,
    ready: false,
  } 

  componentWillReceiveProps({search}) {
    if (search !== this.props.search && search !== '') {
      this.setState({ ready: false })
      this.getSearch(search)
    }
  }

  getFirstCategorie = async (categories) => {
    const category = await categories[0]
    return category
  }

  getSearch = debounce( async (key) => {
    await searchTerm(key).then((data) => {
      if(data.pages.length > 0) {
        this.setState({
          products: data.pages,
          results: data.pages.length,
          filters: data.categories[Object.keys(data.categories)[0]].filters,
          category: Object.keys(data.categories)[0],
        })
        const categories = Object.keys(data.categories).reduce((acc, category) => {
          acc.push({label: category, results: data.categories[category].results, filters: data.categories[category].filters })
          return acc
        }, [])
        this.setState({
          categories: categories,
          ready: true,
        })
      } else {
        this.setState({
          products: [],
          results: 0,
          filters: [],
          category: '',
          ready: true,
        })
      }
    }).catch((e) => {
      console.log('Something wrong with search', e)
    })
  }, 500)

  handlerCategory = (category) => (e) => {
    e.preventDefault()
    const modelsFilters = this.state.categories.filter( category => category.label === 'models')
    this.setState({ 
      category: category,
      filters: category !== 'models' ? [] : modelsFilters[0].filters,
      filterProduct: null,
    })
  }

  getFilters = (filters) => {
    const nProducts = this.state.products
    .filter((product) => this.state.category === product.category.toLowerCase())
    .reduce((productFilters, product) => {
      const isFiltering = Object.keys(filters).reduce((filtering, category) => {
        if (!product.filters.models[category]) {
          filtering = false
        } else {
          filters[category].map((filter) => {
            if (product.filters.models[category].indexOf(filter) === -1) filtering = false
            return filter
          })
        }
        return filtering
      }, true)
      if (isFiltering) productFilters.push(product)
      return productFilters
    }, [])
    this.setState({ filterProduct: Object.keys(filters).length > 0 ? nProducts : null })
  }

  render() {
    const { products, results, categories, filters, filterProduct, ready } = this.state
    return (
      <div className={searchListStyle(ready)}>
        <div className="search-load">
          <Load with={24} height={24} />
        </div>
        <div className="search-transition">
          {
          products && products.length >= 1 && (
            <div>
              <div className="results">
                {results} { results > 1 ? 'results': 'result'} : 
              </div>
              <div className="filters">
                <Pan>
                  <ul className="categories-filter flex flex-nowrap reset">
                    {
                      categories && categories.map((category, index) => (
                        <li className={`category-filter ${category.label === this.state.category ? 'active' : ''}`} key={index} onClick={this.handlerCategory(category.label)}> 
                          { category.label }  {category.results}
                        </li>
                      ))
                    }
                  </ul>
                </Pan>
                {
                  this.state.category === 'models' && (
                    <Filter filters={filters} filtering={this.getFilters} dark/>
                  )
                }
              </div>
              <div className="product-list">
                {
                  filterProduct ?
                  filterProduct.filter((product) => this.state.category === product.category.toLowerCase())
                  .map((product, index) => (
                    <Card {...product} key={index} search label='read more' />
                  )) : 
                  products.filter((product) => this.state.category === product.category.toLowerCase())
                  .map((product, index) => (
                    <Card {...product} key={index} search label='read more' />
                  ))
                }
              </div>
            </div>
          )
        }
        {
          products && products.length === 0 && (
            <p className="no-results">
              No results
            </p>
          )
        }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchList.js